module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.57b8a81c.woff2";